module.exports = __webpack_public_path__ + "img/logo.3a2765df.png";